import { type CreateMultipartResponse, type UploadUrlResponse } from '@air/api/types';
import { type Upload } from '@air/redux-uploader';

import { BaseUploadUrlsManager, type ShouldBatchTogetherParams } from '~/components/Upload/utils/BaseUploadUrlsManager';
import { metadataForPublicUploadSelector } from '~/store/publicUploadMetadata/selectors';
import { type PublicUploadMetadata } from '~/store/publicUploadMetadata/types';
import { sendCreatePublicMultipartUpload } from '~/utils/uploadApi/publicUploadApi/publicLargeUploadApi';
import { fetchSmallPublicUploadUrl } from '~/utils/uploadApi/publicUploadApi/publicSmallUploadApi';

export class GetPublicUploadUrlsManager extends BaseUploadUrlsManager<PublicUploadMetadata> {
  protected getUploadMetadata(uploadId: string): PublicUploadMetadata | undefined {
    return metadataForPublicUploadSelector(this.store.getState(), uploadId);
  }

  protected shouldBatchTogether({
    requestedMetadata,
    otherMetadata,
  }: ShouldBatchTogetherParams<PublicUploadMetadata>): boolean {
    return (
      requestedMetadata.shortBoardId === otherMetadata.shortBoardId &&
      (requestedMetadata.sessionId ?? '') === (otherMetadata.sessionId ?? '')
    );
  }

  protected fetchSmallUploadUrls(uploads: Upload[], metadata: PublicUploadMetadata): Promise<UploadUrlResponse> {
    return fetchSmallPublicUploadUrl({
      shortBoardId: metadata.shortBoardId,
      sessionId: metadata.sessionId ?? '',
      apiUploadData: uploads.map((u) => u.apiUploadData),
    });
  }

  protected fetchLargeUploadUrls(uploads: Upload[], metadata: PublicUploadMetadata): Promise<CreateMultipartResponse> {
    return sendCreatePublicMultipartUpload({
      shortBoardId: metadata.shortBoardId,
      sessionId: metadata.sessionId ?? '',
      apiUploadData: uploads.map((u) => u.apiUploadData),
    });
  }
}
